var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-top-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4423 16.6956C22.6656 16.6981 28.5955 16.6619 28.6199 16.6152C28.7041 16.4531 28.3644 15.5224 27.9945 14.9023C27.6364 14.3016 27.4272 14.0844 22.2295 8.91946L16.8362 3.56001L17.7329 2.66332L18.6296 1.76663L23.6445 6.68722C28.7849 11.7309 29.4998 12.4884 30.1803 13.6123C31.7175 16.1513 31.7778 19.5443 30.3316 22.1326C29.7273 23.2141 29.1651 23.8157 23.8473 29.0709L18.6921 34.1653L17.7959 33.2691L16.8996 32.3729L22.013 27.3002C27.7804 21.5786 28.0387 21.2924 28.4287 20.1909C28.5622 19.8141 28.6443 19.4454 28.6113 19.3713C28.5691 19.2767 24.6445 19.2362 15.4282 19.2354L2.3052 19.2343L2.30285 17.9669C2.30158 17.2699 2.30234 16.6977 2.30469 16.6953C2.30697 16.693 8.21894 16.6932 15.4423 16.6956Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.a033fd60ecce7c8479f13d20c291fb45.svg";
export { ForwardRef as ReactComponent };